<template>
  <el-dialog
    title="新增视频节点"
    :visible="modalOpen"
    :append-to-body="true"
    width="1000px"
    :before-close="handleModalCancel"
  >
    <div class="add-stream-node container-with-collapsible-tree-sidebar">
      <!--侧边栏-->
      <div style="float: left; min-width: 240px; border-right: 1px solid #1DD3B8">
        <div class="general-container">
          <el-input class="search-input"
                    v-model="treeNodeFilter"
                    placeholder="请输入区域名称"
                    clearable>
            <img slot="prefix" src="@/assets/img/icon_search.png">
          </el-input>
        </div>
        <el-tree
          :data="treeData"
          ref="tree"
          default-expand-all
          highlight-current
          node-key="key"
          :props="defaultTreeProps"
          :default-expanded-keys="treeExpandedKeys"
          :expand-on-click-node="false"
          style="height: 400px"
          :filter-node-method="filterTreeNode"
          @node-click="handleTreeNodeClick"
        >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
        </el-tree>
      </div>
      <div class="col-2">
        <div class="pagination-table-container">
          <el-table
            ref="table"
            :data="tableData"
            border
            height="400px"
            @selection-change="handleTableSelectionChange">
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column label="序号" type="index" width="60"></el-table-column>
            <el-table-column label="名称" prop="name"></el-table-column>
            <el-table-column label="监控设备" prop="encoderId">
              <template slot-scope="scope"> {{getNameById(scope.row.encoderId, $globalData.encoders)}} </template>
            </el-table-column>
            <el-table-column label="通道号" prop="encoderVideoInputNum"></el-table-column>
            <el-table-column label="录像状态" prop="centerRecordState">
              <template slot-scope="scope">
                <el-tag :type="scope.row.centerRecordState === 3 ? 'danger'
                  : scope.row.centerRecordState === 2 ? 'warning'
                  :'primary'">
                  {{getNameById(scope.row.centerRecordState, $type.recordStates)}}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            @current-change="handleTableCurrentChange"
            @size-change="handlePageSizeChange"
            :current-page.sync="tableQueryParams.pageNum"
            :page-sizes="[5, 10, 20]"
            :page-size="tableQueryParams.pageSize"
            prev-text="上一页"
            next-text="下一页"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableTotalRow">
          </el-pagination>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleModalSubmit" type="primary">确定</el-button>
      <el-button @click="handleModalCancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import AddStreamNode from './AddStreamNode.js'
export default AddStreamNode
</script>

<style lang="scss">
// @import "AddStreamNode";
</style>



// WEBPACK FOOTER //
// src/views/system/recordTask/addStreamNode/AddStreamNode.vue